import { KoobTitle, KoobParagraph } from '@koob/ui';
import { useTranslation } from 'react-i18next';
import { useAsync } from 'react-async';
import { actingOrganizationOf, get } from '@koob/utils';
import { ReceiptTypeEnum } from './ReceiptTypeEnum';

const getUser = async () => {
  return await get('/api/v1/user');
};

export default function ReceiptHeader({ type = ReceiptTypeEnum.TRIP }) {
  const { t } = useTranslation('trips');

  const { data: userData } = useAsync({
    promiseFn: getUser,
  });
  const user = userData?.data;

  const organizationLogo = actingOrganizationOf(user)?.avatarUrl;

  const isBooking = type === ReceiptTypeEnum.BOOKING;
  const title = isBooking ? t('receipt.titleBooking') : t('receipt.titleTrip');
  const description = isBooking
    ? t('receipt.descriptionBooking')
    : t('receipt.descriptionTrip');

  return (
    <div className="flex justify-between items-center">
      <div>
        <KoobTitle>{title}</KoobTitle>

        <KoobParagraph>{description}</KoobParagraph>
      </div>

      <div className="w-56">
        <img className="w-full object-center" src={organizationLogo} alt="" />
      </div>
    </div>
  );
}
